import { Menu, MerchantItem } from '../../interface';
import { getNavBarItems } from './getNavBarItems';

export function getNavBarLinks(category: Menu<MerchantItem> | MerchantItem): string[] {
  return getNavBarItems(category).map((item) => item.link);
}
